import { BaseEntity } from '../../../../shared-utils/repository/entities/base-entity';

export enum GatewayProviderType {
  PELECARD = 'pelecard',
}

export enum CardBrandType {
  PRIVATE_LABEL = 'private_label',
  MASTERCARD = 'mastercard',
  VISA = 'visa',
  DINERS_CLUB = 'diners_club',
  AMERICAN_EXPRESS = 'american_express',
  ISRACARD = 'isracard',
  JCB = 'jcb',
  DISCOVER = 'discover',
  MAESTRO = 'maestro',
}

export interface CreditCardTokenEntity extends BaseEntity {
  id: number;
  studentId: number;
  gatewayProvider: GatewayProviderType;
  cardBrand: CardBrandType;
  /*token: string;*/
  cardLast4: string;
  isDefault: boolean;
  expiryMonth: number;
  expiryYear: number;
  isActive: boolean;
}
